import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  SelectField,
  TextInput,
  SelectInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  usePermissions,
  BulkDeleteButton,
  ChipField,
} from 'react-admin';

const roleChoices = [
  { id: 'author', name: 'Author' },
  { id: 'editor', name: 'Editor' },
  { id: 'admin', name: 'Admin' },
  { id: 'super_admin', name: 'Super Admin' },
];

const providerChoices = [
  { id: 'google', name: 'Google' },
  { id: 'github', name: 'GitHub' },
];

const adminUserFilters = [
  <TextInput key="email" source="email" label="Email" alwaysOn />,
  <SelectInput key="role" source="role" choices={roleChoices} label="Role" />,
  <SelectInput
    key="oauth_provider"
    source="oauth_provider"
    choices={providerChoices}
    label="Provider"
  />,
];

const ListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <ExportButton />
    </TopToolbar>
  );
};

const BulkActionButtons = () => {
  const { permissions } = usePermissions();
  const canDelete = permissions?.role === 'super_admin';

  return canDelete ? <BulkDeleteButton /> : null;
};

const RoleChip = () => {
  return (
    <ChipField
      source="role"
      sx={{
        '& .MuiChip-label': {
          textTransform: 'capitalize',
        },
      }}
    />
  );
};

export const AdminUserList = () => {
  const { permissions } = usePermissions();
  const canManageUsers =
    permissions?.role === 'super_admin' || permissions?.role === 'admin';

  if (!canManageUsers) {
    return null;
  }

  return (
    <List
      filters={adminUserFilters}
      actions={<ListActions />}
      sort={{ field: 'created_at', order: 'DESC' }}
      perPage={25}
    >
      <Datagrid rowClick="edit" bulkActionButtons={<BulkActionButtons />}>
        <TextField source="display_name" label="Name" />
        <EmailField source="email" label="Email" />
        <RoleChip />
        <SelectField
          source="oauth_provider"
          choices={providerChoices}
          label="Provider"
        />
        <DateField source="last_login_at" label="Last Login" showTime />
        <DateField source="created_at" label="Created" showTime />
      </Datagrid>
    </List>
  );
};
